import * as gmailApi from "@/services/gmail.js";
import * as outlookApi from "@/services/outlook.js";

let client = null;

function initializeApi(settings, firm_id, user_id) {
  if (!settings || !settings['provider']) {
    throw new Error("Settings or provider not specified");
  }

  if (settings['provider'] == 'gmail') {
    client = gmailApi;
  } else if (settings['provider'] == 'outlook') {
    client = outlookApi;
  } else {
      throw new Error("Provider not initialized");
  }
  //returns promise.
  return client.initializeApi(settings, firm_id, user_id);
}


function proxyFunction(name) {
  return function () {
    if (!client) {
      console.log("Client not initialized");
      throw new Error("Client not initialized");
    }
    return client[name].apply(client, arguments);
  };
}

// Background mailbox sync + IndexedDB caching + batch processing is
// desktop-only: it is too heavy for phones (storage, battery, cellular data),
// and OAuth popups (GIS / MSAL) are unreliable inside the WeChat webview.
// Explicit user sign-in is still allowed anywhere; this only gates AUTO-start.
function isEmailSyncSupported() {
  const ua = navigator.userAgent || '';
  return !(/Mobi|Android|iPhone|iPad/i.test(ua)) && !(/MicroMessenger/i.test(ua));
}
//TODO this should just iterate over the apiobjects and add all their methods.
const getEmail = proxyFunction('getEmail');
const getEmails = proxyFunction('getEmails');
const alreadySignedIn = proxyFunction('alreadySignedIn');
const createLabel = proxyFunction('createLabel');
const labelEmail = proxyFunction('labelEmail');
const getMessages = proxyFunction('getMessages');
const signout = proxyFunction('signout');
const authenticate = proxyFunction('authenticate');
const unLabelEmail = proxyFunction('unLabelEmail');
const getBody = proxyFunction('getBody');
const getHeaders = proxyFunction('getHeaders');
const getSubjectLine = proxyFunction('getSubjectLine');
const moreMessages = proxyFunction('moreMessages');
const loadBatch = proxyFunction('loadBatch');
const getThread = proxyFunction('getThread');
const getOldestTimeQuery = proxyFunction('getOldestTimeQuery');
const getNewestTimeQuery = proxyFunction('getNewestTimeQuery');
const platformDate = proxyFunction('platformDate');
const getProfileEmailAddress = proxyFunction('getProfileEmailAddress');
const getEmailAddrs = proxyFunction('getEmailAddrs');
const getThreadSender = proxyFunction('getThreadSender');
const getThreadDate = proxyFunction('getThreadDate');
const getThreadSnippet = proxyFunction('getThreadSnippet');
const getThreadSubject = proxyFunction('getThreadSubject');
const listLabels = proxyFunction('listLabels');
const listMessagesForSync = proxyFunction('listMessagesForSync');
const cacheEntryForMessage = proxyFunction('cacheEntryForMessage');
const listAttachments = proxyFunction('listAttachments');
const fetchAttachmentData = proxyFunction('fetchAttachmentData');

export {
  alreadySignedIn,
  authenticate,
  isEmailSyncSupported,
  createLabel,
  getEmails,
  getEmail,
  labelEmail,
  unLabelEmail,
  signout,
  getMessages,
  initializeApi,
  getBody,
  getHeaders,
  getSubjectLine,
  moreMessages,
  loadBatch,
  getThread,
  getOldestTimeQuery,
  getNewestTimeQuery,
  platformDate,
  getProfileEmailAddress,
  getEmailAddrs,
  getThreadSender,
  getThreadDate,
  getThreadSnippet,
  getThreadSubject,
  listLabels,
  listMessagesForSync,
  cacheEntryForMessage,
  listAttachments,
  fetchAttachmentData,
}

